module.exports = __webpack_public_path__ + "img/savings.341c31b.svg";